import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import Loadable from 'UIComponents/decorators/Loadable';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITile from 'UIComponents/tile/UITile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingComponent = () => {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    "data-test-id": "async-component-loading",
    grow: true,
    minHeight: 200
  });
};
LoadingComponent.displayName = 'AsyncComposeEditor#LoadingComponent';
const ErrorComponent = ({
  retry
}) => {
  return /*#__PURE__*/_jsx(UITile, {
    style: {
      padding: 30
    },
    children: /*#__PURE__*/_jsxs(UIErrorMessage, {
      title: I18n.text('composer-ui.code-splitting.error.title'),
      illustrationProps: {
        width: '100'
      },
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "composer-ui.code-splitting.error.message"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary",
        size: "xs",
        onClick: retry,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "composer-ui.code-splitting.error.button"
        })
      })]
    })
  });
};
ErrorComponent.displayName = 'AsyncComposeEditor#ErrorComponent';
export const AsyncComposeEditor = Loadable({
  loader: () => import( /* webpackChunkName: "compose-editor" */'./ComposeEditor'),
  LoadingComponent,
  ErrorComponent
});